require('./auth/signin');require('./auth/signup');require('./auth/forgot-password');require('./auth/change-password');